const Empty = ({ children }) => {
    return (
        <div className={"bg-gray-50 w-full h-40 p-6 rounded-lg border drop-shadow-sm text-center flex flex-col gap-2 items-center justify-center"}>
            {children}
        </div>
    )
}

export default Empty